import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Drawer, DrawerItem } from '@sitebase/web-shell-kit';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import { LANGUAGE_ITEM_CLICKED, LANGUAGE_SELECT_COMMAND } from '../../../topics';
import { NESTED_LANGUAGE_RENDERER_TYPE } from '../../../rendererTypes';
import { OPENBET_SUPPORTED_LOCALES } from '../../../../const';
import { redirectToOpenbet } from '../redirectToOpenbet';
import renderFlag from '../renderFlag';

const makeOnClick = (data) => () => {
  const { code } = data;

  if (OPENBET_SUPPORTED_LOCALES.includes(code)) {
    redirectToOpenbet(code);
  } else {
    publish({ topic: LANGUAGE_ITEM_CLICKED, data });
  }
};

class NestedLanguageMenu extends Component {
  state = {
    currentLanguageCode: '',
  };

  componentDidMount() {
    this.subscribeId = subscribe({
      topic: LANGUAGE_SELECT_COMMAND,
      callback: ({ data }) => {
        const { currentLanguageCode } = this.state;
        if (currentLanguageCode !== data) {
          this.setState({ currentLanguageCode: data });
        }
      },
    });
  }

  componentWillUnmount() {
    if (this.subscribeId) {
      unsubscribe(this.subscribeId);
    }
  }

  render() {
    const {
      data: { languages, label, id },
    } = this.props;
    const { currentLanguageCode } = this.state;

    const currentLanguage = languages.find((language) => language.code === currentLanguageCode);

    return (
      <DrawerItem
        data-test-id={`${NESTED_LANGUAGE_RENDERER_TYPE}${id ? `_${id}` : ''}`}
        icon={renderFlag(currentLanguage)}
      >
        {(currentLanguage && currentLanguage.label) || label}
        <Drawer data-test-id={`${NESTED_LANGUAGE_RENDERER_TYPE}.dropdown_${id}`}>
          {languages.map((item) => (
            <DrawerItem
              id={`${NESTED_LANGUAGE_RENDERER_TYPE}-${item.code}`}
              key={`${NESTED_LANGUAGE_RENDERER_TYPE}-${item.code}`}
              data-test-id={`${NESTED_LANGUAGE_RENDERER_TYPE}.item_${item.code}`}
              active={currentLanguageCode === item.code}
              onClick={makeOnClick(item)}
              icon={renderFlag(item)}
            >
              {item.label}
            </DrawerItem>
          ))}
        </Drawer>
      </DrawerItem>
    );
  }
}

NestedLanguageMenu.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        data: PropTypes.shape({
          code: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        }),
      })
    ),
  }),
};

// eslint-disable-next-line react/prop-types
const renderFunction = ({ data }) => <NestedLanguageMenu key={data.id} data={data} />;

const buildNestedLanguageMenuRenderer = () => ({
  type: NESTED_LANGUAGE_RENDERER_TYPE,
  render: renderFunction,
  schema: {},
});

const NestedLanguageMenuRenderer = buildNestedLanguageMenuRenderer();

export default NestedLanguageMenuRenderer;
